export default __webpack_public_path__ + "static/media/image 8.d85682df.png";